import { ProgramaService } from "../../../services/ProgramaService";
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import ProgramaForm from "../../../components/forms/ProgramaForm.vue";

export default {
    name: "EditarPrograma",
    components: {
        Breadcrumb,
        ProgramaForm
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Programas',
                disabled: false,
                href: '/gerenciar-programas',
            },
            {
                text: 'Editar Programa',
                disabled: true
            }
        ],
        programaData: null
    }),
    created() {
        this.carregarPrograma();
    },
    methods: {
        async carregarPrograma() {
            try {
                const response = await ProgramaService.show(this.$route.params.id);
                if (response?.data) {
                    this.programaData = {
                        id: response.data.id,
                        exercicio: response.data.exercicio,
                        codigo_programa: response.data.codigo_programa,
                        descricao: response.data.descricao,
                        ativo: Boolean(response.data.ativo)
                    };
                } else {
                    console.error('Não foi possível carregar os dados do Programa.');
                    this.$globalAlert('Erro ao carregar dados do Programa', 'error');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao carregar os dados do Programa:', error);
                this.$globalAlert('Erro ao carregar dados do Programa', 'error');
            }
        },
        async handleSave(formData) {
            try {
                const dataToSend = new FormData();
                dataToSend.append("exercicio", formData.exercicio);
                dataToSend.append("codigo_programa", formData.codigo_programa);
                dataToSend.append("descricao", formData.descricao);
                dataToSend.append("ativo", formData.ativo ? 1 : 0);

                const response = await ProgramaService.update(this.$route.params.id, dataToSend);
                if (response) {
                    this.$router.push('/gerenciar-programas');
                } else {
                    throw new Error('Erro ao atualizar programa');
                }
            } catch (error) {
                console.error('Erro ao salvar:', error);
                this.$globalAlert('Erro ao atualizar Programa');
            }
        },
        handleCancel() {
            this.$router.push('/gerenciar-programas');
        }
    }
};
